<template lang="pug">
  v-alert.mt-4(v-if="showBanner" color="danger500" text)
    v-row.px-1(align='center' dense)
      v-col.pa-0.grow
        div.h6.danger500--text {{ $t('important_notice') }}
        div.caption {{ $t('action') }}
      v-col.pa-0.shrink
        v-btn.px-2(color="danger" small depressed @click="clickActionButton")
          .button-AA-tiny.basic100--text
            span {{ $t('check') }}
</template>

<script>
import { mapActions } from 'vuex'
export default {
  name: 'YezzaPayNotice',
  props: ['company'],
  data: () => ({
    showBanner: false
  }),
  mounted () {
    if (this.company.default_payment_gateway !== 'yezzapay') {
      return
    }
    this.$axios.get(`/yezzapays/?company=${this.company.id}`).then((response) => {
      if (response.data.results.length > 0) {
        let settings = response.data.results[0]
        if (settings.active_fpx_provider === 'yezza_maybank') {
          this.showBanner = true
        }
      }
    })
  },
  methods: {
    ...mapActions(['showMessage']),
    clickActionButton() {
      this.$router.push(`/admin/settings/payment?yezza_pay_notice=true`)
    }
  }
}
</script>

<style lang="scss" scoped>

</style>

<i18n>
{
  "en": {
    "important_notice": "Important Notice",
    "action": "Action required for merchants using Yezza Pay",
    "check": "Check now"
  },
  "ms": {
    "important_notice": "Important Notice",
    "action": "Action required for merchants using Yezza Pay",
    "check": "Check now"
  },
  "id": {
    "important_notice": "Catatan Penting",
    "action": "Aksi yang diperlukan untuk pelanggan yang menggunakan Yezza Pay",
    "check": "Cek sekarang"
  }
}
</i18n>
